module.exports = __webpack_public_path__ + "img/objetos-34.be4c4641.png";